module.exports = __webpack_public_path__ + "static/img/banner2.6d12ac53.jpg";